/**
 * Output Node Component
 *
 * Terminal node for saving workflow results.
 */

import { memo } from 'react';
import { type NodeProps } from '@xyflow/react';
import { BaseNode } from './BaseNode';
import type { NodeData } from '@/types/imageWorkflow';

const ARTIFACT_TYPE_LABELS: Record<string, string> = {
  lucky_charm: '每日幸运符',
  soulmate: '灵魂伴侣',
  soul_echo: '每日回响',
  daily_push: '每日推送',
  natal_report: '占星报告',
  transit_report: '行运报告',
};

const OutputNodeComponent = ({ id, data, selected }: NodeProps) => {
  const nodeData = data as NodeData;

  return (
    <BaseNode id={id} data={nodeData} type="output" selected={selected} hasSourceHandle={false}>
      <div className="space-y-1">
        {/* Artifact Type - Primary display */}
        {nodeData.artifact_type && (
          <div className="flex items-center gap-2">
            <span className="text-blue-500">产物:</span>
            <span className="text-blue-700 font-medium">
              {ARTIFACT_TYPE_LABELS[nodeData.artifact_type as string] || nodeData.artifact_type}
            </span>
          </div>
        )}
        {/* Storage info */}
        <div className="flex items-center gap-2">
          <span className="text-gray-500">Storage:</span>
          <span className="text-gray-700">
            {nodeData.artifact_type
              ? 'Artifact (User)'
              : nodeData.save_to_library
                ? 'Library (Permanent)'
                : 'Temp (7 days)'}
          </span>
        </div>
        {nodeData.save_to_library && nodeData.category && !nodeData.artifact_type && (
          <div className="flex items-center gap-2">
            <span className="text-gray-500">Category:</span>
            <span className="text-gray-700">{String(nodeData.category)}</span>
          </div>
        )}
        {nodeData.filename && (
          <div className="flex items-center gap-2">
            <span className="text-gray-500">Filename:</span>
            <span className="text-gray-700 truncate max-w-[100px]">
              {String(nodeData.filename)}
            </span>
          </div>
        )}
      </div>
    </BaseNode>
  );
};

export const OutputNode = memo(OutputNodeComponent);
export default OutputNode;
